export interface IAccountDetails {
  name: string;
  address: string;
  phone?: string;
  taxId?: string;
  bsb?: string;
  accNo?: string;
  onBehalfOf?: Pick<IAccountDetails, 'name' | 'address'>;
}
